import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function DefiPulse({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 30 30" fill="currentColor">
      <polygon points="9.09 21.52 11.41 23.85 11.62 23.85 9.31 21.52 9.09 21.52" />
      <polygon points="14.29 10.54 12.07 8.31 11.45 8.31 13.67 10.54 14.29 10.54" />
      <polygon points="9.44 21.52 11.77 23.85 12.02 23.85 9.69 21.52 9.44 21.52" />
      <polygon points="13.52 10.54 11.3 8.31 10.98 8.31 13.2 10.54 13.52 10.54" />
      <polygon points="8.78 21.52 11.1 23.85 11.22 23.85 8.94 21.52 8.78 21.52" />
      <polygon points="13.13 10.61 10.83 8.31 10.83 8.86 13.13 11.18 13.13 10.61" />
      <polygon points="13.13 11.32 10.8 9.03 10.8 9.56 13.01 11.77 12.92 11.85 10.79 9.73 10.79 10.28 12.63 12.13 12.55 12.22 10.79 10.44 10.79 11 12.27 12.5 12.2 12.58 10.79 11.18 10.79 11.73 11.91 12.86 11.84 12.96 10.79 11.89 10.79 12.47 11.55 13.22 11.46 13.32 10.79 12.63 10.79 13.19 11.19 13.58 11.1 13.66 10.79 13.36 10.79 19.09 13.13 19.09 13.13 11.32" />
      <polygon points="15.26 10.54 13.05 8.31 12.23 8.31 14.44 10.54 15.26 10.54" />
      <path d="M16.43,9.27l1.48,1.45A4.76,4.76,0,0,0,16.43,9.27Z" />
      <polygon points="18.06 11.05 16.05 9.03 15.6 8.81 17.63 10.85 18.06 11.05" />
      <polygon points="17.39 10.78 15.33 8.69 14.84 8.54 16.96 10.66 17.39 10.78" />
      <path d="M16.05,10.54,13.89,8.36a5.34,5.34,0,0,0-.69,0l2.22,2.23Z" />
      <path d="M13.43,10.85l0,8.27A5.16,5.16,0,0,0,18.69,14c0-.1,0-.21,0-.31a5.63,5.63,0,0,0-.4-2.22,4.32,4.32,0,0,0-2.6-.65Z" />
      <polygon points="16.06 10.54 16.05 10.54 16.06 10.55 16.06 10.54" />
      <polygon points="16.75 10.62 16.74 10.61 16.75 10.62 16.75 10.62" />
      <path d="M16.74,10.61l-2.1-2.13-.55-.1,2.16,2.17Z" />
      <path d="M13.05,21.48l2.32,2.35h.75l-2.34-2.35Z" />
      <path d="M20,18.15l2.36,2.37A7.6,7.6,0,0,0,23,19h0l-2.32-2.33A7,7,0,0,1,20,18.15Z" />
      <path d="M18.91,19.32l2.41,2.37a5.93,5.93,0,0,0,.9-1.1l-2.35-2.34A5.71,5.71,0,0,1,18.91,19.32Z" />
      <path d="M17.91,20.14l2.39,2.41a10,10,0,0,0,.95-.77l-2.38-2.39A6.89,6.89,0,0,1,17.91,20.14Z" />
      <path d="M16.86,20.73l2.39,2.4a6.72,6.72,0,0,0,.95-.52l-2.39-2.39A6.66,6.66,0,0,1,16.86,20.73Z" />
      <polygon points="9.85 21.52 12.18 23.85 12.49 23.85 10.16 21.52 9.85 21.52" />
      <path d="M20.78,16.52l2.29,2.3a8.57,8.57,0,0,0,.37-2.3l-2.23-2.25A9,9,0,0,1,20.78,16.52Z" />
      <path d="M21.17,10.72l-.89-.91a8.46,8.46,0,0,1,1,3.91v.45l2.22,2.24v0a7.64,7.64,0,0,0-2.32-5.67Z" />
      <polygon points="10.31 21.52 12.64 23.85 13.02 23.85 10.7 21.52 10.31 21.52" />
      <polygon points="11.47 21.52 13.8 23.85 14.36 23.85 12.03 21.52 11.47 21.52" />
      <polygon points="10.85 21.52 13.13 23.85 13.59 23.85 11.27 21.52 10.85 21.52" />
      <path d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm.65,24.15H11L8.25,21.42V5.85H13a8.29,8.29,0,0,1,6.15,2.46l2.18,2.17a7.84,7.84,0,0,1,2.39,5.87C23.75,21,20.41,24.15,15.65,24.15Z" />
      <path d="M15.83,21.1h0l2.39,2.39a6.63,6.63,0,0,0,1-.32l-2.42-2.45A5.53,5.53,0,0,1,15.83,21.1Z" />
      <path d="M14.83,21.34h0l2.37,2.39c.31-.06.6-.12.89-.2l-2.37-2.38A7,7,0,0,1,14.83,21.34Z" />
      <polygon points="12.18 21.52 14.51 23.85 15.18 23.85 12.84 21.52 12.18 21.52" />
      <path d="M13.93,21.46l2.35,2.35a2.86,2.86,0,0,0,.82-.08l-2.37-2.38A7.32,7.32,0,0,1,13.93,21.46Z" />
    </SvgIcon>
  )
}
